import React from "react";
import Grid from "@material-ui/core/Grid";

import styles from "./size-info.module.scss";
import image from "../../../assets/images/size-info/full_print_tanktop.png";

function FullPrintTanktop() {
  return (
    <Grid container className={styles.sizeInfo}>
      <Grid item xs={12}>
        <h2 className={styles.sizeInfoTitle}>
          Возьмите вашу любимую майку или футболку и проведите измерения:
        </h2>
      </Grid>
      <Grid item xs={12} md={4} className={styles.sizeInfoImage}>
        <img src={image} />
      </Grid>
      <Grid item xs={12} md={8}>
        <ol>
          <li>
            Измерьте ширину изделия по груди, как указано на рисунке в таблице
            размеров (с).
          </li>
          <li>Измерьте длину спины по центру (d).</li>
          <li>
            В нашей таблице размеров найдите показатели, которые наиболее точно
            соответствуют получившимся цифрам.
          </li>
        </ol>
      </Grid>
    </Grid>
  );
}

FullPrintTanktop.propTypes = {};

export default FullPrintTanktop;
